module.exports = "<div class=\"no-content\">\r\n    <div>\r\n      <div class=\"icon-wrap-xxl mb-5\">\r\n        <div></div>\r\n      </div>\r\n      <h1 class=\"display-2\">{{ title }}</h1>\r\n      <div class=\"text-muted\">{{ description }}</div>\r\n    </div>\r\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/no-content/no-content.component.html
// module id = ./src/app/shared/no-content/no-content.component.html
// module chunks = main